module.exports = __webpack_public_path__ + "img/features_img_manajemenkontak.7535d53b.png";